import * as z from "zod";

export const DEFAULT_ONBOARDING_ABANDONMENT_DELAY_HOURS = 2;
export const MIN_ONBOARDING_ABANDONMENT_DELAY_HOURS = 1;
export const MAX_ONBOARDING_ABANDONMENT_DELAY_HOURS = 24;

export const onboardingAbandonmentDelayHoursSchema = z
  .number()
  .int()
  .min(MIN_ONBOARDING_ABANDONMENT_DELAY_HOURS)
  .max(MAX_ONBOARDING_ABANDONMENT_DELAY_HOURS);
